import {type Client} from '@bugsnag/core'
import BugsnagHelper from '@frontrow/console/src/entities/helpers/exception-handlers/bugsnag-helper'
import {globalConsoleAgent} from '@frontrow/console/src/helpers/auth-helpers'

const bugsnagClient = BugsnagHelper.init(() => globalConsoleAgent) as Client

export default bugsnagClient
